import React$1 from 'react';

const Right = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "39"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M19.5.5C30.27.5 39 9.007 39 19.5s-8.73 19-19.5 19S0 29.993 0 19.5 8.73.5 19.5.5zm0 2C9.824 2.5 2 10.123 2 19.5c0 9.377 7.824 17 17.5 17S37 28.877 37 19.5c0-9.377-7.824-17-17.5-17zM17 11.586L25.414 20 17 28.414 15.586 27l6.999-7-7-7L17 11.586z"
}));

export default Right;
